
import React, {useState} from 'react';
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import {Link, useParams} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import PaginationRaw from "@/components/pagination/PaginationRaw";
import RenderLoading from "@/components/render-if-loading";
import TeacherHomeworkCard from "@/pages/teacher/lessons/[id]/homework/_section/HomeworkCard";
import {useApiSearchTeacherHomeworks} from "@/api/homework";
import {Button, Empty} from "antd";
import RenderIf from "@/components/render-if";

function TeacherLessonHomeworkPage() {
    const {id} = useParams();

    const [search, setSearch] = useState('');
    const [sortBy, setSortBy] = useState('');
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(15)

    const {data: homeworks, isPending} = useApiSearchTeacherHomeworks({lesson_id: id})

    return (
        <TeacherLayout backTo={sprintf(URLS.teacher.lessons.detail, {id: id})} pageTitle={'مشاهده تکالیف'}>
            <div className={'flex justify-between items-center mb-2'}>
                <div></div>
                <div>
                    <Link to={sprintf(URLS.teacher.lessons.homeworksCreate, {id: id})}>
                        <Button color={'primary'} variant={'solid'}>افزودن تکلیف جدید</Button>
                    </Link>
                </div>
            </div>

            <RenderIf condition={homeworks?.data?.data.length === 0}>
                <div className="rounded-xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 p-6">
                    <Empty
                        description={
                            <span className="text-gray-600 dark:text-gray-300">
                                هیچ تکلیفی ثبت نشده است
                            </span>
                        }
                    />
                </div>
            </RenderIf>

            <RenderLoading loading={isPending} skeleton={true}>
                <div className={'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6'}>
                    {homeworks?.data?.data.map((homework, i) => (
                        <div key={i} className="min-w-0">
                            <TeacherHomeworkCard homework={homework} />
                        </div>
                    ))}
                </div>
            </RenderLoading>

            <PaginationRaw data={homeworks?.data} setPage={setPage} setPerPage={setPerPage}/>
        </TeacherLayout>
    );
}

export default TeacherLessonHomeworkPage;
